import React from "react";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";

const CategoryForm = ({ initialData, onSuccess, onError }) => {
  return (
    <MasterDataFormV2
      title="Category"
      apiUrl="/inventory-category"
      initialData={initialData}
      fields={[
        {
          name: "name",
          label: "Category Name",
          type: "text",
          required: true,
          maxLength: 255,
          placeholder: "e.g., Engine Parts, Brake System",
        },
        {
          name: "color",
          label: "Category Color",
          type: "color",
          required: false,
          defaultValue: "#FF6B6B",
          helpText:
            "Choose a color to identify this category in the inventory table",
        },
        {
          name: "description",
          label: "Description",
          type: "textarea",
          required: false,
          rows: 3,
          placeholder: "Optional description for this category",
        },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default CategoryForm;
